import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { fetchTicketHelpers } from "../ticketSlice";
import Loader from "../../subsidiary/Loader/Loader";
import styles from '../Tickets.module.css';
import { useNavigate } from "react-router-dom";

// Желаемый порядок: сначала аппарат, затем группа по финансово-экономической работе
const APPARATUS_ORDER = ['Троицкая МВ', 'Олина МВ', 'Яруничева ИИ', 'Кирилюк ПЭ', 'Пашова ЕВ', 'Власова АВ'];
const FINANCIAL_GROUP_LABEL = 'Группа по финансово-экономической работе';
// У этих специалистов не показывать блок «Что я могу узнать у данного специалиста»
const HIDE_SKILLS_CAPTION_FOR = ['Пашова', 'Власова'];

const sortHelpers = (list) => {
    if (!Array.isArray(list)) return [];
    const byName = {};
    list.forEach((h) => { byName[h.full_name?.trim() || ''] = h; });
    const ordered = [];
    const added = new Set();
    APPARATUS_ORDER.forEach((name) => {
        const helper = byName[name];
        if (helper) {
            ordered.push(helper);
            added.add(helper.id);
        }
    });
    list.forEach((h) => {
        if (!added.has(h.id)) ordered.push(h);
    });
    return ordered;
};

const shouldShowSkillsCaption = (fullName) => {
    if (!fullName) return true;
    return !HIDE_SKILLS_CAPTION_FOR.some((part) => fullName.includes(part));
};

const TicketPage = () => {
    const helpers = useSelector((state) => state?.ticketSlice.ticketHelpers);
    const loading = useSelector((state) => state?.ticketSlice.helpersLoading);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const sortedHelpers = useMemo(() => sortHelpers(helpers), [helpers]);

    useEffect(() => {
        dispatch(fetchTicketHelpers());
    }, [dispatch]);

    const renderSkills = (helper) => {
        const skills = helper.skills;
        const hasSkills = Array.isArray(skills) ? skills.length > 0 : skills;
        const showCaption = shouldShowSkillsCaption(helper.full_name);
        if (!hasSkills) return null;
        const raw = Array.isArray(skills) ? skills.join('') : skills;
        const content = raw == null ? '' : typeof raw === 'string' ? raw : String(raw);
        return (
            <div className={styles.helper_skills}>
                {showCaption && (
                    <span className={styles.skills_title}>
                        Что я могу узнать у данного специалиста?:
                    </span>
                )}
                <div style={{ marginTop: '5px', lineHeight: '26px' }} dangerouslySetInnerHTML={{ __html: content }} />
            </div>
        );
    };

    return (
        <>
            {!loading ? (
                <section className="main">
                    <div className="content-wrapper">
                        <div className="page-title-container">
                            <h1 className="page-title">Аппарат ОППО</h1>
                        </div>
                        {sortedHelpers.map((helper) => (
                            <React.Fragment key={helper?.id ?? helper?.full_name}>
                                {(helper.full_name?.includes('Пашова') || helper.full_name?.includes('Пашева')) && (
                                    <h2 className={styles.ticket_group_title}>{FINANCIAL_GROUP_LABEL}</h2>
                                )}
                                <div className={styles.ticket_card}>
                                    <img src={helper.image} alt="" />
                                    <div className={styles.helper_info}>
                                        <span className={styles.ticket_title}>{helper.full_name}</span>
                                        <span className={styles.ticket_subtitle}>Должность:</span>
                                        <span className={styles.subtitle_description}>
                                            {helper.position?.trim() || '—'}
                                        </span>
                                    </div>
                                    {renderSkills(helper)}
                                </div>
                            </React.Fragment>
                        ))}
                        <div className={styles.button_container}>
                            <button onClick={() => navigate('/tickets/newticket')} className={styles.ticket_button}>
                                Задать вопрос ОППО
                            </button>
                        </div>
                    </div>
                </section>
            ) : (
                <Loader />
            )}
        </>
    );
};

export default TicketPage;